module.exports = __webpack_public_path__ + "img/w3_pdf_dark.c88ca801.png";